export const API_URL = (window as any).ENVIRONMENT.REACT_APP_API_URL;
export const BRAZE_SDK_URL = (window as any).ENVIRONMENT.BRAZE_SDK_URL;
export const TMN_APP_CLOSE_WEB_VIEW_LINK = `${(window as any).ENVIRONMENT.REACT_APP_TMN_DEEP_LINK}://closewebview`;
export const TMN_APP_FUND_IN_PAGE = `${(window as any).ENVIRONMENT.REACT_APP_TMN_DEEP_LINK}://${
    (window as any).ENVIRONMENT.REACT_APP_TMN_API_URL
}/app/660000000004`;
export const GA_TRACKING_CODE = (window as any).ENVIRONMENT.GA_TRACKING_CODE;
export const TRUEMONEY_TRANSFER_LOCATION = 'https://truemoneytransfer.truemoney.com/location/';
export const TRUEMONEY_TRANSFER_CHAT_WITH_STAFF = (window as any).ENVIRONMENT.TRUEMONEY_TRANSFER_CHAT_WITH_STAFF;
export const TMN_APP_VERSION = (window as any).ENVIRONMENT.TMN_APP_VERSION;
export const MINIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.MINIMUM_TRANSFER_AMOUNT;
export const MAXIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.MAXIMUM_TRANSFER_AMOUNT;
export const RECEIVER_MAXIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.RECEIVER_MAXIMUM_TRANSFER_AMOUNT;

export const MYANMAR_MINIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.MYANMAR_MINIMUM_TRANSFER_AMOUNT;
export const MYANMAR_MAXIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.MYANMAR_MAXIMUM_TRANSFER_AMOUNT;
export const MYANMAR_MINIMUM_TRANSFER_AMOUNT_IN_THB = (window as any).ENVIRONMENT.MYANMAR_MINIMUM_TRANSFER_AMOUNT_IN_THB;
export const MYANMAR_MAXIMUM_TRANSFER_AMOUNT_IN_THB = (window as any).ENVIRONMENT.MYANMAR_MAXIMUM_TRANSFER_AMOUNT_IN_THB;
export const CAMBODIA_MINIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.CAMBODIA_MINIMUM_TRANSFER_AMOUNT;
export const CAMBODIA_MAXIMUM_TRANSFER_AMOUNT = (window as any).ENVIRONMENT.CAMBODIA_MAXIMUM_TRANSFER_AMOUNT;
export const CAMBODIA_MINIMUM_TRANSFER_AMOUNT_IN_THB = (window as any).ENVIRONMENT.CAMBODIA_MINIMUM_TRANSFER_AMOUNT_IN_THB;
export const CAMBODIA_MAXIMUM_TRANSFER_AMOUNT_IN_THB = (window as any).ENVIRONMENT.CAMBODIA_MAXIMUM_TRANSFER_AMOUNT_IN_THB;

export const IOS_VERSION = (window as any).ENVIRONMENT.IOS_VERSION;
export const ANDROID_VERSION = (window as any).ENVIRONMENT.ANDROID_VERSION;
export const CHROME_VERSION = (window as any).ENVIRONMENT.CHROME_VERSION;
export const SAFARI_VERSION = (window as any).ENVIRONMENT.SAFARI_VERSION;
export const COUNTRY = [
    {
        code: '95',
        name: 'Myanmar',
        language: 'my',
        iso_code: 'mm',
        currency_code: 'MMK',
        national_id_length: 6,
        ga_infix: 'mm',
        minimum_mobile_length: 9,
        maximum_mobile_length: 11,
    },
    {
        code: '855',
        name: 'Cambodia',
        language: 'km',
        iso_code: 'kh',
        currency_code: 'KHR',
        national_id_length: 9,
        ga_infix: 'cm',
        minimum_mobile_length: 9,
        maximum_mobile_length: 10,
    },
];

export interface ConfigAttribute {
    TMN_APP_FUND_IN_PAGE: string;
    MINIMUM_TRANSFER_AMOUNT: number;
    MAXIMUM_TRANSFER_AMOUNT: number;
    MYANMAR_MINIMUM_TRANSFER_AMOUNT: number;
    MYANMAR_MAXIMUM_TRANSFER_AMOUNT: number;
    MYANMAR_MINIMUM_TRANSFER_AMOUNT_IN_THB: number;
    MYANMAR_MAXIMUM_TRANSFER_AMOUNT_IN_THB: number;
    CAMBODIA_MINIMUM_TRANSFER_AMOUNT: number;
    CAMBODIA_MAXIMUM_TRANSFER_AMOUNT: number;
    CAMBODIA_MINIMUM_TRANSFER_AMOUNT_IN_THB: number;
    CAMBODIA_MAXIMUM_TRANSFER_AMOUNT_IN_THB: number;
}
